(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@splat/constant"), require("@splat/theme"), require("@splat/checkbox"), require("csstips"), require("csx"), require("typestyle"), require("vue-property-decorator"), require("vue-tsx-support"));
	else if(typeof define === 'function' && define.amd)
		define([, , , , , , , ], factory);
	else if(typeof exports === 'object')
		exports["tree"] = factory(require("@splat/constant"), require("@splat/theme"), require("@splat/checkbox"), require("csstips"), require("csx"), require("typestyle"), require("vue-property-decorator"), require("vue-tsx-support"));
	else
		root["tree"] = factory(root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__splat_constant__, __WEBPACK_EXTERNAL_MODULE__splat_theme__, __WEBPACK_EXTERNAL_MODULE__splat_checkbox__, __WEBPACK_EXTERNAL_MODULE_csstips__, __WEBPACK_EXTERNAL_MODULE_csx__, __WEBPACK_EXTERNAL_MODULE_typestyle__, __WEBPACK_EXTERNAL_MODULE_vue_property_decorator__, __WEBPACK_EXTERNAL_MODULE_vue_tsx_support__) {
return /******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/style.ts":
/*!**********************!*\
  !*** ./src/style.ts ***!
  \**********************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "treeNodePadding": function() { return /* binding */ treeNodePadding; },
/* harmony export */   "iconClassName": function() { return /* binding */ iconClassName; },
/* harmony export */   "iconHoverClassName": function() { return /* binding */ iconHoverClassName; },
/* harmony export */   "showChildrenClassName": function() { return /* binding */ showChildrenClassName; },
/* harmony export */   "showChildrenDisabledClassName": function() { return /* binding */ showChildrenDisabledClassName; },
/* harmony export */   "iconDisplayClassName": function() { return /* binding */ iconDisplayClassName; },
/* harmony export */   "treeTitleClassName": function() { return /* binding */ treeTitleClassName; },
/* harmony export */   "treeIconClassName": function() { return /* binding */ treeIconClassName; },
/* harmony export */   "searchIconClassName": function() { return /* binding */ searchIconClassName; },
/* harmony export */   "treeNodeClassName": function() { return /* binding */ treeNodeClassName; },
/* harmony export */   "virtualScrollHiddenDashClassName": function() { return /* binding */ virtualScrollHiddenDashClassName; },
/* harmony export */   "treeNodeCountClassName": function() { return /* binding */ treeNodeCountClassName; },
/* harmony export */   "treeNodeContentClassName": function() { return /* binding */ treeNodeContentClassName; },
/* harmony export */   "arrowChooseItemClassName": function() { return /* binding */ arrowChooseItemClassName; },
/* harmony export */   "treeClassName": function() { return /* binding */ treeClassName; },
/* harmony export */   "hideClassName": function() { return /* binding */ hideClassName; },
/* harmony export */   "slotsHoverClassName": function() { return /* binding */ slotsHoverClassName; },
/* harmony export */   "showHoverClassName": function() { return /* binding */ showHoverClassName; },
/* harmony export */   "checkedTreeNodeClassName": function() { return /* binding */ checkedTreeNodeClassName; },
/* harmony export */   "cursorDefaultClassName": function() { return /* binding */ cursorDefaultClassName; },
/* harmony export */   "addonClassName": function() { return /* binding */ addonClassName; },
/* harmony export */   "hrClassName": function() { return /* binding */ hrClassName; },
/* harmony export */   "treeContainerClassName": function() { return /* binding */ treeContainerClassName; },
/* harmony export */   "treeAdonLabelClassName": function() { return /* binding */ treeAdonLabelClassName; },
/* harmony export */   "noMarginLeftClassName": function() { return /* binding */ noMarginLeftClassName; },
/* harmony export */   "checkboxItemContentClassName": function() { return /* binding */ checkboxItemContentClassName; },
/* harmony export */   "iconMarginLeftClassName": function() { return /* binding */ iconMarginLeftClassName; },
/* harmony export */   "checkboxClassName": function() { return /* binding */ checkboxClassName; },
/* harmony export */   "checkboxLabelClassName": function() { return /* binding */ checkboxLabelClassName; },
/* harmony export */   "treeNodeDirectClassName": function() { return /* binding */ treeNodeDirectClassName; },
/* harmony export */   "treeNodeDirHoverClassName": function() { return /* binding */ treeNodeDirHoverClassName; },
/* harmony export */   "addNameColorClassName": function() { return /* binding */ addNameColorClassName; },
/* harmony export */   "virtualWrappperClassName": function() { return /* binding */ virtualWrappperClassName; },
/* harmony export */   "virtualWrapperDashClassName": function() { return /* binding */ virtualWrapperDashClassName; },
/* harmony export */   "inlineBlockClassName": function() { return /* binding */ inlineBlockClassName; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @splat/constant */ "@splat/constant");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_splat_constant__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var csstips__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! csstips */ "csstips");
/* harmony import */ var csstips__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(csstips__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var csx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! csx */ "csx");
/* harmony import */ var csx__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(csx__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! typestyle */ "typestyle");
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(typestyle__WEBPACK_IMPORTED_MODULE_4__);





var treeNodePadding = 22;
var iconClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  position: 'relative',
  top: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(1),
  transitionProperty: 'transform',
  transitionDuration: '.3s',
  marginRight: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(7),
  transform: (0,csx__WEBPACK_IMPORTED_MODULE_3__.rotateZ)((0,csx__WEBPACK_IMPORTED_MODULE_3__.deg)(0)),
  '-webkit-transform': (0,csx__WEBPACK_IMPORTED_MODULE_3__.rotateZ)((0,csx__WEBPACK_IMPORTED_MODULE_3__.deg)(0)),
  fontSize: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(14),
  color: (0,csx__WEBPACK_IMPORTED_MODULE_3__.important)('#919191'),
  zIndex: 1
});
var iconHoverClassName = function iconHoverClassName(theme) {
  return (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
    $nest: {
      '&:hover': {
        color: (0,csx__WEBPACK_IMPORTED_MODULE_3__.important)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.TreeColors.themePrimary(theme).toString())
      }
    }
  });
};
var showChildrenClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  $nest: (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])({}, "&.".concat(iconClassName), {
    transform: (0,csx__WEBPACK_IMPORTED_MODULE_3__.rotateZ)((0,csx__WEBPACK_IMPORTED_MODULE_3__.deg)(90)),
    '-webkit-transform': (0,csx__WEBPACK_IMPORTED_MODULE_3__.rotateZ)((0,csx__WEBPACK_IMPORTED_MODULE_3__.deg)(90))
  })
});
var showChildrenDisabledClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  visibility: 'hidden'
});
var iconDisplayClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  display: 'none'
});
var treeTitleClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  fontSize: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(14)
});
var treeIconClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  fontSize: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(12),
  width: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(14),
  height: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(14),
  cursor: 'pointer',
  $nest: {
    '&:hover': {
      color: '#333333'
    }
  }
});
var searchIconClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)((0,csstips__WEBPACK_IMPORTED_MODULE_2__.padding)(4, 3), {
  cursor: 'pointer',
  color: '#BFBFBF',
  position: 'relative',
  lineHeight: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(16),
  $nest: {
    '&:hover': {
      color: '#333333'
    },
    '&:after': {
      content: '""',
      height: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(16),
      width: 1,
      position: 'absolute',
      background: '#E9E9E9',
      left: 0,
      top: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(4)
    }
  }
});
var treeNodeClassName = function treeNodeClassName(left, level) {
  var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var hasChildren = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var selectable = arguments.length > 4 ? arguments[4] : undefined;
  var verticalHeight = arguments.length > 5 ? arguments[5] : undefined;
  var multipleRoot = arguments.length > 6 ? arguments[6] : undefined;
  var leaf = arguments.length > 7 ? arguments[7] : undefined;
  return (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
    // marginLeft: px(22),
    position: 'relative',
    $nest: {
      // 竖线，root节点和子级节点位置不同, root最后一个节点没有竖线
      '&:after': {
        content: '""',
        borderLeft: '1.5px dashed #d9d9d9',
        height: verticalHeight,
        position: 'absolute',
        top: level === 0 ? (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(16) : index === 0 ? (0,csx__WEBPACK_IMPORTED_MODULE_3__.percent)(-35) : hasChildren ? (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(-16) : (0,csx__WEBPACK_IMPORTED_MODULE_3__.percent)(-50),
        left: level === 0 ? (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(left - 20) : (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(left - 19),
        zIndex: 10
      },
      // 横线， 每一个节点都有横线 （只有一个root节点除外
      '&:before': {
        content: '""',
        borderTop: '1.5px dashed #d9d9d9',
        width: level === 0 ? index === 0 && !multipleRoot ? undefined : (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(17) : leaf ? selectable ? (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(20) : (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(12) : (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(10),
        height: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(0),
        position: 'absolute',
        top: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(16),
        left: level === 0 ? (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(left - 20) : (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(left - 19)
      }
    }
  });
};
var virtualScrollHiddenDashClassName = function virtualScrollHiddenDashClassName(virtualHeight, level, nextBorderIndex) {
  return (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
    $nest: {
      '&:after': {
        borderLeft: '1.5px dashed #d9d9d9',
        top: (0,csx__WEBPACK_IMPORTED_MODULE_3__.important)((0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(-virtualHeight)),
        height: (0,csx__WEBPACK_IMPORTED_MODULE_3__.important)((0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(virtualHeight + (nextBorderIndex > 0 ? nextBorderIndex * 32 : 0) + 16))
      }
    }
  });
};
var treeNodeCountClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  color: '#BFBFBF'
});
var treeNodeContentClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  height: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(32)
});
var arrowChooseItemClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  background: '#F5F5F5'
});
var treeClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  // position: 'relative',
  fontSize: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(12),
  lineHeight: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(32),
  whiteSpace: 'nowrap',
  flex: 1
});
var hideClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  display: 'none'
});
var slotsHoverClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  color: '#666'
});
var showHoverClassName = function showHoverClassName(theme) {
  return (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
    $nest: {
      '&:hover': {
        color: (0,csx__WEBPACK_IMPORTED_MODULE_3__.important)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.TreeColors.themePrimary(theme).toString()),
        cursor: 'pointer',
        $nest: (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])({
          '& label': {
            color: (0,csx__WEBPACK_IMPORTED_MODULE_3__.important)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.TreeColors.themePrimary(theme).toString())
          }
        }, "& .".concat(slotsHoverClassName), {
          color: (0,csx__WEBPACK_IMPORTED_MODULE_3__.important)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.TreeColors.themePrimary(theme).toString())
        })
      }
    }
  });
};
var checkedTreeNodeClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  color: (0,csx__WEBPACK_IMPORTED_MODULE_3__.important)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.CommonColors.primary.toString()),
  cursor: 'pointer'
});
var cursorDefaultClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  cursor: 'default'
});
var addonClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  fontSize: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(14),
  color: '#333333',
  $nest: {
    '&:hover': {
      color: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.CommonColors.primary.toString()
    },
    '&:after': {
      content: '""',
      borderLeft: '1px solid #e9e9e9',
      height: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(65),
      position: 'absolute',
      top: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(-24),
      right: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(-10)
    }
  }
});
var hrClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  border: 'none',
  width: (0,csx__WEBPACK_IMPORTED_MODULE_3__.percent)(100),
  borderTop: '1px solid #f5f5f5'
});
var treeContainerClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)(csstips__WEBPACK_IMPORTED_MODULE_2__.flexRoot, csstips__WEBPACK_IMPORTED_MODULE_2__.betweenJustified, {
  height: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(400),
  overflowY: 'scroll'
});
var treeAdonLabelClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)(csstips__WEBPACK_IMPORTED_MODULE_2__.flexRoot, csstips__WEBPACK_IMPORTED_MODULE_2__.betweenJustified, {
  width: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(100),
  display: 'inline-block',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  verticalAlign: 'middle'
});
var noMarginLeftClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  marginLeft: 0
});
var checkboxItemContentClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  color: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.CommonColors.regularText.toString(),
  marginLeft: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(1)
});
var iconMarginLeftClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  marginLeft: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(7),
  top: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(1)
});
var checkboxClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  top: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(1)
});
var checkboxLabelClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  top: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(2)
});
var treeNodeDirectClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  paddingLeft: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(16),
  borderRadius: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(4)
});
var treeNodeDirHoverClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  $nest: {
    '&:hover': {
      background: '#f5f5f5'
    }
  }
});
var addNameColorClassName = function addNameColorClassName(theme) {
  return (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
    color: (0,csx__WEBPACK_IMPORTED_MODULE_3__.important)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.TreeColors.themePrimary(theme).toString()),
    fontWeight: 900
  });
};
var virtualWrappperClassName = function virtualWrappperClassName(num) {
  return (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
    height: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(num),
    overflowY: 'auto',
    $nest: {
      '& > div': {
        position: 'relative'
      }
    }
  });
};
var virtualWrapperDashClassName = function virtualWrapperDashClassName(level) {
  return (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
    position: 'absolute',
    top: 0,
    left: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(level ? level * 22 + 1 : 0),
    height: (0,csx__WEBPACK_IMPORTED_MODULE_3__.percent)(100),
    borderLeft: '1.5px dashed #d9d9d9'
  });
};
var inlineBlockClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  display: 'inline-block'
});

/***/ }),

/***/ "./src/tree.tsx":
/*!**********************!*\
  !*** ./src/tree.tsx ***!
  \**********************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js");
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/assertThisInitialized */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/inherits.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @splat/constant */ "@splat/constant");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_splat_constant__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _splat_theme__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @splat/theme */ "@splat/theme");
/* harmony import */ var _splat_theme__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_splat_theme__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _splat_checkbox__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @splat/checkbox */ "@splat/checkbox");
/* harmony import */ var _splat_checkbox__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_splat_checkbox__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _style__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./style */ "./src/style.ts");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var vue_tsx_support__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! vue-tsx-support */ "vue-tsx-support");
/* harmony import */ var vue_tsx_support__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(vue_tsx_support__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! typestyle */ "typestyle");
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(typestyle__WEBPACK_IMPORTED_MODULE_14__);









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : (0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__["default"])(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};









var Tree = /*#__PURE__*/function (_tsx$Component) {
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__["default"])(Tree, _tsx$Component);

  var _super = _createSuper(Tree);

  function Tree() {
    var _this;

    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__["default"])(this, Tree);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "data", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "nodeKey", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "nodeFilter", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "disableCheck", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "selectable", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "showHover", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "defaultExpand", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "expanded", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "collapsed", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "selected", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "dashLine", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "treeName", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "showClickHightLight", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "saveClickHightLightItem", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "arrowNodeKey", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "virtualScroller", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "strictSelect", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "status", new Map());

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "hightLightKey", null);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "shownDatas", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "accShownDatas", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "flatData", []);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "flatDataHeight", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "shownDataLength", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "virtualOffsetY", 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "virtualStartIndex", 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "virtualEndIndex", 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "virtualDash", []);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "iconHandleClickThrottle", (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.throttle)(_this.iconHandleClick, 50));

    return _this;
  }

  (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__["default"])(Tree, [{
    key: "onGetShownData",
    value: function onGetShownData(v) {}
  }, {
    key: "onClickHightLight",
    value: function onClickHightLight(val) {}
  }, {
    key: "onGetItemNode",
    value: function onGetItemNode(v) {}
  }, {
    key: "handleNodeSelect",
    value: function handleNodeSelect(keys, selected) {}
  }, {
    key: "handleNodeExpand",
    value: function handleNodeExpand(key, expanded) {}
  }, {
    key: "handleDataChanged",
    value: function handleDataChanged() {
      this.walkVirtualTree();
    }
  }, {
    key: "handleNodeKeyChanged",
    value: function handleNodeKeyChanged() {
      this.walkVirtualTree();
    }
  }, {
    key: "handleSelectedChanged",
    value: function handleSelectedChanged() {
      this.walkVirtualTree();
    }
  }, {
    key: "handleCollapsedChanged",
    value: function handleCollapsedChanged() {
      this.walkVirtualTree();
    }
  }, {
    key: "handleExpandedChanged",
    value: function handleExpandedChanged() {
      this.walkVirtualTree();
    }
  }, {
    key: "handleNodeFilterChanged",
    value: function handleNodeFilterChanged() {
      this.walkVirtualTree();
    }
  }, {
    key: "handleDisableCheckChanged",
    value: function handleDisableCheckChanged() {
      this.walkVirtualTree();
    }
  }, {
    key: "handleVirtualHeightChanged",
    value: function handleVirtualHeightChanged(v) {
      if (!v) return;
      this.virtualStartIndex = 0;
      this.virtualEndIndex = Math.ceil(v.height / 32);
      this.shownDataLength = Math.ceil(v.height / 32);
    }
  }, {
    key: "handleSaveClickItem",
    value: function handleSaveClickItem(v) {
      this.hightLightKey = this.nodeKey(v);
    }
  }, {
    key: "handleArrowNodeKey",
    value: function handleArrowNodeKey(v) {
      var _this2 = this;

      if (v) {
        this.$nextTick(function () {
          _this2.onGetItemNode(document.querySelector(".".concat(_style__WEBPACK_IMPORTED_MODULE_11__.arrowChooseItemClassName)));
        });
      }
    }
  }, {
    key: "shownVirtualData",
    get: function get() {
      var flatData = this.flatData,
          virtualStartIndex = this.virtualStartIndex,
          virtualEndIndex = this.virtualEndIndex;
      return flatData.slice(virtualStartIndex, virtualEndIndex > this.flatData.length - 1 ? this.flatData.length : virtualEndIndex);
    }
  }, {
    key: "multipleRoot",
    get: function get() {
      return this.flatData.filter(function (v) {
        return v.level === 0;
      }).length > 1;
    }
  }, {
    key: "walkTree",
    value: function walkTree(cb, data, nodeKey, selectedNodes, parentSelected, defaultExpand, collapsedNodes, expandedNodes, nodeFilter, disableCheck) {
      var _this3 = this,
          _this$virtualDash$lev;

      var anceExpand = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : true;

      var _splatParent = arguments.length > 11 ? arguments[11] : undefined;

      var totalLevel = arguments.length > 12 ? arguments[12] : undefined;
      var level = totalLevel !== null && totalLevel !== void 0 ? totalLevel : 0;
      var key = nodeKey(data);
      var expanded = defaultExpand ? !collapsedNodes.includes(key) : expandedNodes.includes(key);
      var ancExpand = anceExpand ? expanded : anceExpand;

      if (data.children && data !== null && data !== void 0 && data.filterChildKeys) {
        data.filterChildKeys = [];
      }

      var curSelected = parentSelected || selectedNodes.includes(key);
      var childStatus = data.children ? data.children.map(function (c) {
        return _this3.walkTree(cb, c, nodeKey, selectedNodes, curSelected, defaultExpand, collapsedNodes, expandedNodes, nodeFilter, disableCheck, ancExpand, data, level + 1);
      }) : undefined;
      _splatParent ? data._splatParent = _splatParent : null;
      var disabled = false;

      if (this.strictSelect) {
        disabled = parentSelected ? parentSelected : disableCheck ? disableCheck(data) : false;
      } else {
        var _this$status$get;

        var innerDisabled = (_this$status$get = this.status.get(key)) === null || _this$status$get === void 0 ? void 0 : _this$status$get.disabled;
        disabled = typeof innerDisabled === 'boolean' ? innerDisabled : disableCheck ? disableCheck(data) : false;
      }

      var shown = nodeFilter ? nodeFilter(data) : (data === null || data === void 0 ? void 0 : data.visible) !== false;
      var childSelected = false;
      var selected = selectedNodes.includes(key);
      var leafNum = data.leaf && shown ? 1 : 0;
      var leafSelected = selected && data.leaf && shown ? 1 : 0;

      if (childStatus && childStatus.length) {
        childSelected = childStatus.some(function (c) {
          return c.selected || c.childSelected;
        });
        shown = shown || childStatus.some(function (c) {
          return c.shown;
        });
        childStatus.map(function (item) {
          leafNum += item.leafNum;
          leafSelected += item.leafSelected;
        });
      }

      data.leafNum = leafNum;
      data.leafSelected = leafSelected;

      if (this.virtualScroller && !((_this$virtualDash$lev = this.virtualDash[level]) !== null && _this$virtualDash$lev !== void 0 && _this$virtualDash$lev.show) === true) {
        var _this$virtualDash$lev2;

        this.virtualDash[level] && ((_this$virtualDash$lev2 = this.virtualDash[level]) === null || _this$virtualDash$lev2 === void 0 ? void 0 : _this$virtualDash$lev2.show) === false ? this.virtualDash[level].show = true : this.virtualDash[level] = {
          show: false
        };
      }

      if (anceExpand && shown && _splatParent) {
        _splatParent.filterChildKeys ? _splatParent.filterChildKeys = _splatParent.filterChildKeys.concat(key) : _splatParent.filterChildKeys = [].concat(key);
      }

      var status = {
        disabled: disabled,
        selected: selected,
        expanded: expanded,
        shown: shown,
        childSelected: childSelected,
        leafNum: leafNum,
        leafSelected: leafSelected,
        anceExpand: anceExpand
      };
      cb(key, status);
      return status;
    }
  }, {
    key: "walkVirtualTree",
    value: function walkVirtualTree() {
      var data = this.data,
          status = this.status,
          nodeKey = this.nodeKey,
          selected = this.selected,
          defaultExpand = this.defaultExpand,
          collapsed = this.collapsed,
          expanded = this.expanded,
          nodeFilter = this.nodeFilter,
          disableCheck = this.disableCheck,
          flatShownValue = this.flatShownValue,
          virtualScroller = this.virtualScroller,
          walkTree = this.walkTree;
      data.forEach(function (d) {
        return walkTree(function (key, nodeStatus) {
          return status === null || status === void 0 ? void 0 : status.set(key, nodeStatus);
        }, d, nodeKey, selected, false, defaultExpand, collapsed, expanded, nodeFilter, disableCheck);
      });
      this.flatData = flatShownValue(this.data);

      if (virtualScroller) {
        this.flatDataHeight = this.flatData.length * 32;
      }
    }
  }, {
    key: "flatShownValue",
    value: function flatShownValue(data) {
      var nodeKey = this.nodeKey,
          status = this.status;
      return (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.flatNested)('children', data, undefined, undefined, undefined, undefined, false).filter(function (v) {
        var key = nodeKey(v);
        var stat = status.get(key);
        return (stat === null || stat === void 0 ? void 0 : stat.shown) && stat.anceExpand;
      });
    }
  }, {
    key: "handleShownDatasChanged",
    value: function handleShownDatasChanged() {
      var _this4 = this;

      var nodeKey = this.nodeKey;

      if (!this.accShownDatas || this.shownDatas.length != this.accShownDatas.length) {
        this.accShownDatas = this.shownDatas;
        this.onGetShownData(this.shownDatas);
        return;
      }

      var repeat = this.shownDatas.every(function (v, i) {
        return nodeKey(v) === nodeKey(_this4.accShownDatas[i]);
      });

      if (!repeat) {
        this.accShownDatas = this.shownDatas;
        this.onGetShownData(this.shownDatas);
      }
    }
  }, {
    key: "iconHandleClick",
    value: function iconHandleClick(key, stat) {
      var handleNodeExpand = this.handleNodeExpand;
      handleNodeExpand(key, !stat.expanded);
    }
  }, {
    key: "shownData",
    get: function get() {
      var data = this.data,
          status = this.status,
          nodeKey = this.nodeKey;
      return data.filter(function (r) {
        var _status$get;

        return (_status$get = status.get(nodeKey(r))) === null || _status$get === void 0 ? void 0 : _status$get.shown;
      });
    }
  }, {
    key: "renderIcon",
    value: function renderIcon(key, stat, node, leaf) {
      var _node$children;

      var h = this.$createElement;
      var dashLine = this.dashLine,
          iconHandleClickThrottle = this.iconHandleClickThrottle,
          treeName = this.treeName,
          selectable = this.selectable,
          theme = this.theme;
      return h("i", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_14__.classes)("sl-id-tree__caret__".concat(key), "sl-id-tree__caret__".concat(key, "-").concat(stat.expanded ? 'expanded' : 'collapsed'), 'el-icon-caret-right', _style__WEBPACK_IMPORTED_MODULE_11__.iconClassName, leaf && _style__WEBPACK_IMPORTED_MODULE_11__.iconMarginLeftClassName, !node.leaf && _style__WEBPACK_IMPORTED_MODULE_11__.iconHoverClassName(theme), stat.expanded && _style__WEBPACK_IMPORTED_MODULE_11__.showChildrenClassName, node.leaf && (!dashLine || selectable) && _style__WEBPACK_IMPORTED_MODULE_11__.showChildrenDisabledClassName, node.leaf && !selectable && _style__WEBPACK_IMPORTED_MODULE_11__.iconDisplayClassName),
        "style": {
          left: node.leaf && !selectable ? '10px' : null
        },
        "attrs": {
          "id": leaf ? undefined : "sl-id-tree__caret__".concat(treeName, "_").concat(key),
          "disabled": !((_node$children = node.children) !== null && _node$children !== void 0 && _node$children.length)
        },
        "on": {
          "click": function click(e) {
            iconHandleClickThrottle(key, stat);
            (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.preventStop)()(e);
          }
        }
      });
    }
  }, {
    key: "checkboxHandleClick",
    value: function checkboxHandleClick(node, key, stat, status) {
      var handleNodeSelect = this.handleNodeSelect,
          nodeKey = this.nodeKey,
          showClickHightLight = this.showClickHightLight;
      if (stat.disabled) return;
      var flatNode = (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.flatNested)('children', [node]);
      handleNodeSelect(flatNode.filter(function (n) {
        var _status$get2;

        return (_status$get2 = status.get(nodeKey(n))) === null || _status$get2 === void 0 ? void 0 : _status$get2.shown;
      }).map(function (f) {
        return nodeKey(f);
      }), !stat.selected);

      if (showClickHightLight) {
        this.hightLightKey = key;
        this.onClickHightLight(node);
      }
    }
  }, {
    key: "renderCheckboxDefaultSlot",
    value: function renderCheckboxDefaultSlot(stat, key, node, leaf, name) {
      var h = this.$createElement;
      var theme = this.theme;
      return leaf ? null : h("span", {
        "class": (stat.selected || this.hightLightKey === key) && _style__WEBPACK_IMPORTED_MODULE_11__.addNameColorClassName(theme)
      }, [name, this.$scopedSlots.content ? h("span", {
        "class": _style__WEBPACK_IMPORTED_MODULE_11__.treeNodeCountClassName
      }, [this.$scopedSlots.content(node)]) : null]);
    }
  }, {
    key: "renderCheckbox",
    value: function renderCheckbox(key, stat, node, status, name, leaf) {
      var h = this.$createElement;
      var treeName = this.treeName,
          checkboxHandleClick = this.checkboxHandleClick,
          renderCheckboxDefaultSlot = this.renderCheckboxDefaultSlot;
      return h((_splat_checkbox__WEBPACK_IMPORTED_MODULE_10___default()), {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_14__.classes)(_style__WEBPACK_IMPORTED_MODULE_11__.checkboxLabelClassName, "sl-id-tree__checkbox__".concat(key), stat.selected && "sl-id-tree__checkbox__".concat(key, "-selected"), stat.childSelected && "sl-id-tree__checkbox__".concat(key, "-clild-selected"), leaf && _style__WEBPACK_IMPORTED_MODULE_11__.checkboxClassName),
        "attrs": {
          "id": leaf ? "sl-id-tree__caret__".concat(treeName, "_").concat(key) : undefined,
          "value": stat.selected || stat.childSelected,
          "disabled": stat.disabled,
          "smallSize": true,
          "indeterminate": !stat.selected && stat.childSelected
        },
        "on": {
          "click": function click() {
            return checkboxHandleClick(node, key, stat, status);
          }
        }
      }, [renderCheckboxDefaultSlot(stat, key, node, leaf, name)]);
    }
  }, {
    key: "render",
    value: function render(h) {
      var data = this.data,
          nodeKey = this.nodeKey,
          renderNode = this.renderNode,
          selectable = this.selectable,
          showHover = this.showHover,
          status = this.status,
          virtualScroller = this.virtualScroller,
          flatData = this.flatData,
          flatDataHeight = this.flatDataHeight,
          virtualOffsetY = this.virtualOffsetY,
          virtualDash = this.virtualDash,
          virtualStartIndex = this.virtualStartIndex,
          virtualEndIndex = this.virtualEndIndex,
          treeName = this.treeName,
          dashLine = this.dashLine;
      return h("div", {
        "ref": 'tree',
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_14__.classes)(_style__WEBPACK_IMPORTED_MODULE_11__.treeClassName, virtualScroller && _style__WEBPACK_IMPORTED_MODULE_11__.virtualWrappperClassName(virtualScroller.height), (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.createSplatClassName)('tree', treeName))
      }, [virtualScroller ? h("div", {
        "style": {
          height: "".concat(flatDataHeight, "px")
        }
      }, [h("div", {
        "attrs": {
          "id": 'sl-virtual-scroll-wrapper'
        },
        "style": {
          transform: "translateY(".concat(virtualOffsetY, "px)")
        }
      }, [this.shownVirtualData.map(function (n, i) {
        var node = renderNode(h, n, n.level, status, flatData.indexOf(n), flatData, selectable, showHover, nodeKey(data[data.length - 1]) === nodeKey(n));
        return node;
      }), dashLine ? virtualDash.map(function (v, i) {
        if (!v.show || !(virtualStartIndex > 0)) return null;
        var preData = flatData.slice(0, virtualStartIndex);
        var preIndex = preData.reverse().findIndex(function (v) {
          return v.level === i;
        });
        if (preIndex === -1) return null;
        var apIndex = flatData.slice(virtualEndIndex).findIndex(function (v) {
          return v.level === i;
        });
        if (apIndex === -1) return null;
        var cur = flatData.slice(preData.length - preIndex, apIndex + virtualEndIndex).every(function (v) {
          return v.level > i;
        });
        return cur ? h("div", {
          "class": _style__WEBPACK_IMPORTED_MODULE_11__.virtualWrapperDashClassName(i)
        }) : null;
      }) : null])]) : flatData.map(function (n, i) {
        var node = renderNode(h, n, n.level, status, i, flatData, selectable, showHover, nodeKey(data[data.length - 1]) === nodeKey(n));
        return node;
      })]);
    }
  }, {
    key: "renderVirtualScrollHiddenDash",
    value: function renderVirtualScrollHiddenDash(node, level, index) {
      var virtualOffsetY = this.virtualOffsetY,
          virtualScroller = this.virtualScroller,
          flatData = this.flatData,
          shownVirtualData = this.shownVirtualData;

      if (virtualOffsetY === 0 || level === 0 && index === 0 || flatData[index - 1] && flatData[index - 1].level < level) {
        return null;
      }

      var reverse = flatData.slice(0, index).reverse();
      var preBorder = reverse[reverse.findIndex(function (v) {
        return v.level === level;
      })];
      var nextBorderIndex = flatData.slice(index + 1).findIndex(function (v) {
        return v.level === level;
      });
      var useIndex = flatData.slice(index + 1, index + nextBorderIndex + 1).every(function (v) {
        return v.level > level;
      });
      return shownVirtualData.indexOf(preBorder) > -1 ? null : _style__WEBPACK_IMPORTED_MODULE_11__.virtualScrollHiddenDashClassName(virtualScroller.height, level, useIndex ? nextBorderIndex + 1 : 0);
    }
  }, {
    key: "renderNode",
    value: function renderNode(h, node, level, status, index, flatData, selectable, showHover, isLast) {
      var _node$_splatParent,
          _node$_splatParent2,
          _node$_splatParent3,
          _node$_splatParent3$f,
          _node$_splatParent4,
          _this5 = this;

      var nodeKey = this.nodeKey,
          handleNodeSelect = this.handleNodeSelect,
          dashLine = this.dashLine,
          showClickHightLight = this.showClickHightLight,
          arrowNodeKey = this.arrowNodeKey,
          handleShownDatasChanged = this.handleShownDatasChanged,
          theme = this.theme,
          renderVirtualScrollHiddenDash = this.renderVirtualScrollHiddenDash,
          multipleRoot = this.multipleRoot;
      var key = nodeKey(node);
      var stat = status.get(key);
      if (index === 0 && level === 0) this.shownDatas = [];
      this.shownDatas.push(node);
      var name = this.$scopedSlots.name ? this.$scopedSlots.name(node) : key;
      var last = node !== null && node !== void 0 && (_node$_splatParent = node._splatParent) !== null && _node$_splatParent !== void 0 && _node$_splatParent.filterChildKeys ? node._splatParent.filterChildKeys[node._splatParent.filterChildKeys.length - 1] === key : isLast;
      var childIndex = index;

      if ((_node$_splatParent2 = node._splatParent) !== null && _node$_splatParent2 !== void 0 && _node$_splatParent2.children) {
        var startIndex = flatData.findIndex(function (v) {
          return nodeKey(v) === nodeKey(node._splatParent);
        }) + 1;
        var endIndex = flatData.slice(startIndex).findIndex(function (v) {
          return v.level === level - 1;
        });
        childIndex = flatData.slice(startIndex, endIndex === -1 ? undefined : startIndex + endIndex).findIndex(function (v) {
          return nodeKey(v) === nodeKey(node);
        });
      }

      var shownNode = h("div", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_14__.classes)('tree-node', "sl-id-tree__node__".concat(key), level === 0 && 'root', dashLine && _style__WEBPACK_IMPORTED_MODULE_11__.treeNodeClassName(_style__WEBPACK_IMPORTED_MODULE_11__.treeNodePadding * level + 20, level, childIndex, node.children && node.children.length > 0, selectable, index != 0 && flatData[index - 1].level < level ? 32 * 0.85 + 32 * ((node === null || node === void 0 ? void 0 : (_node$_splatParent3 = node._splatParent) === null || _node$_splatParent3 === void 0 ? void 0 : (_node$_splatParent3$f = _node$_splatParent3.filterChildKeys) === null || _node$_splatParent3$f === void 0 ? void 0 : _node$_splatParent3$f.length) > 1 ? flatData.slice(index + 1).findIndex(function (v) {
          return v.level === level;
        }) : 0) : !(node !== null && node !== void 0 && node._splatParent) && last ? 0 : (!flatData[index + 1] && index !== 0 || last && !!(node !== null && node !== void 0 && (_node$_splatParent4 = node._splatParent) !== null && _node$_splatParent4 !== void 0 && _node$_splatParent4.filterChildKeys) && flatData[index + 1] || flatData[index + 1].level < level ? 1 : flatData.slice(index + 1).findIndex(function (v) {
          return v.level === level;
        }) + 1) * 32, multipleRoot, node.leaf), renderVirtualScrollHiddenDash(node, level, index))
      }, [h("div", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_14__.classes)(dashLine && _style__WEBPACK_IMPORTED_MODULE_11__.treeNodeDirectClassName, dashLine && showHover && _style__WEBPACK_IMPORTED_MODULE_11__.treeNodeDirHoverClassName)
      }, [h("div", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_14__.classes)('tree-content', "sl-id-tree__content__".concat(key), _style__WEBPACK_IMPORTED_MODULE_11__.treeNodeContentClassName, arrowNodeKey === key && _style__WEBPACK_IMPORTED_MODULE_11__.arrowChooseItemClassName, showHover ? _style__WEBPACK_IMPORTED_MODULE_11__.showHoverClassName(theme) : _style__WEBPACK_IMPORTED_MODULE_11__.cursorDefaultClassName),
        "style": {
          paddingLeft: "".concat(_style__WEBPACK_IMPORTED_MODULE_11__.treeNodePadding * level, "px")
        },
        "on": {
          "click": function click(e) {
            if (stat.disabled) return;
            handleNodeSelect((0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.flatNested)('children', [node]).filter(function (n) {
              var _status$get3;

              return (_status$get3 = status.get(nodeKey(n))) === null || _status$get3 === void 0 ? void 0 : _status$get3.shown;
            }).map(function (f) {
              return nodeKey(f);
            }), !stat.selected);

            if (showClickHightLight) {
              _this5.hightLightKey = key;

              _this5.onClickHightLight(node);
            }

            (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.preventStop)()(e);
          }
        }
      }, [this.renderIcon(key, stat, node), selectable ? node.leaf ? h("div", {
        "class": _style__WEBPACK_IMPORTED_MODULE_11__.inlineBlockClassName
      }, [this.renderCheckbox(key, stat, node, status, name, node.leaf), h("span", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_14__.classes)(_style__WEBPACK_IMPORTED_MODULE_11__.checkboxItemContentClassName, this.hightLightKey === key && _style__WEBPACK_IMPORTED_MODULE_11__.addNameColorClassName(theme))
      }, [name, this.$scopedSlots.content ? h("span", {
        "class": _style__WEBPACK_IMPORTED_MODULE_11__.treeNodeCountClassName
      }, [this.$scopedSlots.content(node)]) : null])]) : this.renderCheckbox(key, stat, node, status, name, node.leaf) : h("span", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_14__.classes)(_style__WEBPACK_IMPORTED_MODULE_11__.slotsHoverClassName, this.hightLightKey === key && _style__WEBPACK_IMPORTED_MODULE_11__.addNameColorClassName(theme))
      }, [name, this.$scopedSlots.content ? h("span", {
        "class": _style__WEBPACK_IMPORTED_MODULE_11__.treeNodeCountClassName
      }, [this.$scopedSlots.content(node)]) : null])])])]);

      if (index === flatData.length - 1) {
        handleShownDatasChanged();
      }

      return shownNode;
    }
  }, {
    key: "handleVirtualScroll",
    value: function handleVirtualScroll(e) {
      var shownDataLength = this.shownDataLength;
      var scrollTop = e.target.scrollTop;
      var currentStartIndex = Math.floor(scrollTop / 32);
      this.virtualOffsetY += (currentStartIndex - this.virtualStartIndex) * 32;
      this.virtualStartIndex = currentStartIndex;
      this.virtualEndIndex = currentStartIndex + shownDataLength;
    }
  }, {
    key: "handleVirtualMouseEnter",
    value: function handleVirtualMouseEnter(e) {
      ;
      e.target.style.willChange = 'change';
    }
  }, {
    key: "handleVirtualMouseLeave",
    value: function handleVirtualMouseLeave(e) {
      ;
      e.target.style.willChange = 'auto';
    }
  }, {
    key: "mounted",
    value: function mounted() {
      var walkVirtualTree = this.walkVirtualTree,
          virtualScroller = this.virtualScroller,
          handleVirtualScroll = this.handleVirtualScroll,
          handleVirtualMouseEnter = this.handleVirtualMouseEnter,
          handleVirtualMouseLeave = this.handleVirtualMouseLeave,
          treeName = this.treeName;
      walkVirtualTree();

      if (virtualScroller) {
        var treeWrapper = document.querySelector(".".concat((0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.createSplatClassName)('tree', treeName)));
        treeWrapper === null || treeWrapper === void 0 ? void 0 : treeWrapper.addEventListener('scroll', handleVirtualScroll, true);
        treeWrapper === null || treeWrapper === void 0 ? void 0 : treeWrapper.addEventListener('mouseenter', handleVirtualMouseEnter);
        treeWrapper === null || treeWrapper === void 0 ? void 0 : treeWrapper.addEventListener('mouseleave', handleVirtualMouseLeave);
      }
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      var handleVirtualScroll = this.handleVirtualScroll,
          handleVirtualMouseEnter = this.handleVirtualMouseEnter,
          handleVirtualMouseLeave = this.handleVirtualMouseLeave,
          treeName = this.treeName;
      var treeWrapper = document.querySelector(".".concat((0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.createSplatClassName)('tree', treeName)));
      treeWrapper === null || treeWrapper === void 0 ? void 0 : treeWrapper.addEventListener('scroll', handleVirtualScroll, true);
      treeWrapper === null || treeWrapper === void 0 ? void 0 : treeWrapper.addEventListener('mouseenter', handleVirtualMouseEnter);
      treeWrapper === null || treeWrapper === void 0 ? void 0 : treeWrapper.addEventListener('mouseleave', handleVirtualMouseLeave);
    }
  }]);

  return Tree;
}(vue_tsx_support__WEBPACK_IMPORTED_MODULE_13__.Component);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Prop)()], Tree.prototype, "data", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Prop)()], Tree.prototype, "nodeKey", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Prop)()], Tree.prototype, "nodeFilter", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Prop)()], Tree.prototype, "disableCheck", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Prop)({
  default: true
})], Tree.prototype, "selectable", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Prop)({
  default: true
})], Tree.prototype, "showHover", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Prop)()], Tree.prototype, "defaultExpand", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Prop)()], Tree.prototype, "expanded", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Prop)()], Tree.prototype, "collapsed", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Prop)()], Tree.prototype, "selected", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Prop)()], Tree.prototype, "dashLine", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Prop)({
  default: 'tree'
})], Tree.prototype, "treeName", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Prop)()], Tree.prototype, "showClickHightLight", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Prop)()], Tree.prototype, "saveClickHightLightItem", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Prop)()], Tree.prototype, "arrowNodeKey", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Prop)()], Tree.prototype, "virtualScroller", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Prop)()], Tree.prototype, "strictSelect", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Emit)('getShownData')], Tree.prototype, "onGetShownData", null);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Emit)('clickHightLight')], Tree.prototype, "onClickHightLight", null);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Emit)('getItemNode')], Tree.prototype, "onGetItemNode", null);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Emit)('nodeSelect')], Tree.prototype, "handleNodeSelect", null);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Emit)('nodeExpand')], Tree.prototype, "handleNodeExpand", null);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Watch)('data', {
  immediate: true
})], Tree.prototype, "handleDataChanged", null);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Watch)('nodeKey')], Tree.prototype, "handleNodeKeyChanged", null);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Watch)('selected')], Tree.prototype, "handleSelectedChanged", null);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Watch)('collapsed')], Tree.prototype, "handleCollapsedChanged", null);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Watch)('expanded')], Tree.prototype, "handleExpandedChanged", null);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Watch)('nodeFilter')], Tree.prototype, "handleNodeFilterChanged", null);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Watch)('disableCheck')], Tree.prototype, "handleDisableCheckChanged", null);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Watch)('virtualScroller', {
  immediate: true
})], Tree.prototype, "handleVirtualHeightChanged", null);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Watch)('saveClickHightLightItem')], Tree.prototype, "handleSaveClickItem", null);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Watch)('arrowNodeKey')], Tree.prototype, "handleArrowNodeKey", null);

Tree = __decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Component)({
  mixins: [(_splat_theme__WEBPACK_IMPORTED_MODULE_9___default())]
})], Tree);
/* harmony default export */ __webpack_exports__["default"] = (Tree);

/***/ }),

/***/ "@splat/checkbox":
/*!*****************************************************************************!*\
  !*** external {"commonjs":"@splat/checkbox","commonjs2":"@splat/checkbox"} ***!
  \*****************************************************************************/
/***/ (function(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE__splat_checkbox__;

/***/ }),

/***/ "@splat/constant":
/*!*****************************************************************************!*\
  !*** external {"commonjs":"@splat/constant","commonjs2":"@splat/constant"} ***!
  \*****************************************************************************/
/***/ (function(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE__splat_constant__;

/***/ }),

/***/ "@splat/theme":
/*!***********************************************************************!*\
  !*** external {"commonjs":"@splat/theme","commonjs2":"@splat/theme"} ***!
  \***********************************************************************/
/***/ (function(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE__splat_theme__;

/***/ }),

/***/ "csstips":
/*!*************************************************************!*\
  !*** external {"commonjs":"csstips","commonjs2":"csstips"} ***!
  \*************************************************************/
/***/ (function(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE_csstips__;

/***/ }),

/***/ "csx":
/*!*****************************************************!*\
  !*** external {"commonjs":"csx","commonjs2":"csx"} ***!
  \*****************************************************/
/***/ (function(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE_csx__;

/***/ }),

/***/ "typestyle":
/*!*****************************************************************!*\
  !*** external {"commonjs":"typestyle","commonjs2":"typestyle"} ***!
  \*****************************************************************/
/***/ (function(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE_typestyle__;

/***/ }),

/***/ "vue-property-decorator":
/*!*******************************************************************************************!*\
  !*** external {"commonjs":"vue-property-decorator","commonjs2":"vue-property-decorator"} ***!
  \*******************************************************************************************/
/***/ (function(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE_vue_property_decorator__;

/***/ }),

/***/ "vue-tsx-support":
/*!*****************************************************************************!*\
  !*** external {"commonjs":"vue-tsx-support","commonjs2":"vue-tsx-support"} ***!
  \*****************************************************************************/
/***/ (function(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE_vue_tsx_support__;

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js":
/*!**********************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js ***!
  \**********************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _assertThisInitialized; }
/* harmony export */ });
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js":
/*!************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js ***!
  \************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _createClass; }
/* harmony export */ });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _getPrototypeOf; }
/* harmony export */ });
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/inherits.js":
/*!*********************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/inherits.js ***!
  \*********************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _inherits; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./setPrototypeOf.js */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js");

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__["default"])(subClass, superClass);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js":
/*!**************************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js ***!
  \**************************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _possibleConstructorReturn; }
/* harmony export */ });
/* harmony import */ var _typeof_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./typeof.js */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js");
/* harmony import */ var _assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./assertThisInitialized.js */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js");


function _possibleConstructorReturn(self, call) {
  if (call && ((0,_typeof_js__WEBPACK_IMPORTED_MODULE_0__["default"])(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return (0,_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__["default"])(self);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js":
/*!*******************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js ***!
  \*******************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
!function() {
/*!**********************!*\
  !*** ./src/index.ts ***!
  \**********************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _tree__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./tree */ "./src/tree.tsx");

/* harmony default export */ __webpack_exports__["default"] = (_tree__WEBPACK_IMPORTED_MODULE_0__["default"]);
}();
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=index.js.map